import React from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { markVideoFeaturedAction, unMarkVideoFeaturedAction } from 'common/actions/index';
import { SimpleDropDownElement } from 'components/simple-dropdown/index';

export const ToggleFeaturedMenuItem = (props) => {
  const { t } = useTranslation();
  const { video, pageNumber, sort } = props;
  const dispatch = useDispatch();

  const unMarkVideoFeatured = () => {
    dispatch(unMarkVideoFeaturedAction(video, pageNumber, sort));
  };

  const markVideoFeatured = () => {
    dispatch(markVideoFeaturedAction(video, pageNumber, sort));
  };

  return (
    <SimpleDropDownElement
      onClick={video.featured ? unMarkVideoFeatured : markVideoFeatured}
      data-e2e="toggle-featured"
    >
      {video.featured ? t('unmark_featured') : t('mark_featured')}
    </SimpleDropDownElement>
  );
};

ToggleFeaturedMenuItem.propTypes = {
  video: PropTypes.object.isRequired,
  pageNumber: PropTypes.number,
  sort: PropTypes.string,
};
